import { render } from "./SliceForm.vue?vue&type=template&id=6ee14cfa&scoped=true&ts=true"
import script from "./SliceForm.vue?vue&type=script&lang=ts"
export * from "./SliceForm.vue?vue&type=script&lang=ts"

import "./SliceForm.vue?vue&type=style&index=0&id=6ee14cfa&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ee14cfa"]])

export default __exports__